import Aux from "./Aux"

class Callbacks {
  static filterToFormHandler() {
    return function filterToForm(filter) {
      return {
        audience: 'all',
        type: ['alert', 'message'],
        model: 'standard',
        ...filter
      }
    }
  }
  static formToFilterHandler() {
    return function formToFilter(values, extra, meta, state) {
      return {
        audience: _.get(values, 'is_paired') || undefined,
        drivers: _.get(values, 'drivers'),
        driver_options: _.get(values, 'driver_options'),
        vehicle_options: _.get(values, 'vehicle_options'),
        vehicletypes: values?.vehicletypes,
        type: _.get(values, 'type'),
        cities: _.get(values, 'cities'),
        job: values.model === 'job' ? { '!': null } : null,
        billing_category: _.get(values, 'billing_category'),
        title: !!_.get(values, 'title') ? { 'contains': values.title } : undefined,
        body: !!_.get(values, 'body') ? { 'contains': values.body } : undefined,
        createdAt: Aux.formatCreatedAt(_.get(values, 'createdAt_start'), _.get(values, 'createdAt_end'))
      }
    }
  }
}

export default Callbacks
